import {DATE_TYPE} from "../enums/dateType";
import moment from "moment";
import {FIELD_TYPE} from "../enums/fieldType";

export const getFormIdFromReportRowKey = (reportRowKey) => {
  if (typeof reportRowKey === 'string') {
    return reportRowKey.slice(0, reportRowKey.indexOf('_'));
  }
  return null
}

// TODO: change it because 'select2' field type is returned as 'select' now (because of regex that removes all numbers
export const getFieldTypeFromFieldName = (reportRowKey) => {
  if (typeof reportRowKey === 'string') {
    let withoutNumbers = reportRowKey.replace(/[0-9]/g, '');

    let startFrom = 0;
    for (let i = 0; i < withoutNumbers.length; i++) {
      if (withoutNumbers.charAt(i) === '-' || withoutNumbers.charAt(i) === '_') {
        startFrom = i + 1;
      } else {
        break;
      }
    }

    let fieldNameUnserialized = withoutNumbers.substring(startFrom, withoutNumbers.length);

    if (fieldNameUnserialized.charAt(fieldNameUnserialized.length - 1) === '-' || fieldNameUnserialized.charAt(fieldNameUnserialized.length - 1) === '_') {
      fieldNameUnserialized = fieldNameUnserialized.slice(0, -1) // remove last char
    }

    return fieldNameUnserialized
  }
  return null
}


export const isDate = (value) => {
  const date = moment(value);
  return date.isValid()
}

export const isJSON = (string) => {
  try {
    JSON.parse(string);
  } catch (e) {
    return false;
  }
  return true;
}

// returns string or false if not found
export const getFieldDisplayTypeFromSchemaByName = (fieldName, schema) => {
  if (!Array.isArray(schema) || schema.length < 1) {
    return null
  }

  const field = schema.find(field => {
    return field.name === fieldName
  })

  if (!field || !field.type) {
    return false
  }

  if (field.type === FIELD_TYPE.SHARED_FIELD) {
    return field.displayType
  }
  return field.type
}

export const isFieldDateDisplayType = (fieldName, schema) => {
  return getFieldDisplayTypeFromSchemaByName(fieldName, schema) === 'date'
}

// returns array of strings or null
export const getSpecificPropertyFromAllFieldsOfSpecificTypeInSchema = (fieldType, schema, propertyType = 'name') => {
  if (!Array.isArray(schema) || schema.length < 1) {
    return null
  }
  return schema.map(field => {
    if (field.type && field.type === fieldType) {
      return field[propertyType]
    }
  }).filter(elem => {
    return elem !== undefined
  })
}


export const sanitizeHtml = (text) => {
  if (text) {
    const toReplace = [
      ['&', '&amp'],
      ['<', '&lt'],
      ['>', '&gt'],
      ['"', '&quot'],
      ["'", '&#x27'],
    ]

    toReplace.forEach(([a, b]) => {
      text = text.replaceAll(a, b);
    })
  }
  return text;
}



// WEBPACK FOOTER //
// ./src/utils/functions.js